import Link from 'next/link';
import React, { FC } from 'react';
import Typo from '../Typography/Typo';
import CommentIcon from '../CommentsSection/Icons/CommentIcon';
import { COMMENTS_SECTION_ID } from '../CommentsSection/utils/constants';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';

type TArticleToolbarCommentsCounterProps = {
  commentsCount: number;
};

const ArticleToolbarCommentsCounter: FC<TArticleToolbarCommentsCounterProps> = ({ commentsCount }) => {
  const { sendEvent } = useAnalytics();

  const handleCommentsCounterClick = () => {
    sendEvent('post_comments_counter_click');
  };

  return (
    <Link onClick={handleCommentsCounterClick} href={`#${COMMENTS_SECTION_ID}`}>
      <Typo
        variant="p2"
        className="flex items-center gap-x-[14px] md:!text-p4 stroke-black-700 hover:!stroke-orange-500 text-black-700 hover:text-orange-500 stroke-[1.5px]"
      >
        <CommentIcon /> {commentsCount || 0}
      </Typo>
    </Link>
  );
};

export default ArticleToolbarCommentsCounter;
